import React from 'react'
import PropTypes from 'prop-types'
import { StyledContainer, ContentContainer, StyledText, WillCharacter } from './ErrorPage.styles'
import Link from 'components/UI/Link'
import { Button } from 'nzk-react-components'

const ObjectNotFoundError = (props) => {
  return (
    <StyledContainer color={props.bgColor || '#512B6F'}>
      <ContentContainer>
        <StyledText>{props.objectTitle} not found</StyledText>
        { props.link && <Link to={props.link}>
          <Button
            theme='primary'
            size='regular'
          >
            Back
          </Button>
        </Link> }
        { props.action && <Button
          theme='primary'
          size='regular'
          onClick={props.action}
        >
          Back
        </Button>
        }
      </ContentContainer>
      <WillCharacter />
    </StyledContainer>
  )
}

ObjectNotFoundError.propTypes = {
  objectTitle: PropTypes.string.isRequired,
  action: PropTypes.func,
  link: PropTypes.string,
  bgColor: PropTypes.string
}

export default ObjectNotFoundError
